export function sanitizeProps(props = {}) {
  const filteredProps = {};
  Object.keys(props).forEach((key) => {
    if (key !== 'errorView' && key !== 'client' && key !== '__typename') {
      filteredProps[key] = props[key];
    }
  });
  return filteredProps;
}

export function logAnalitycsEvent(name, mergedData) {
  const { RVN, log } = window;
  if (RVN.isDebugMode && log && log.info) {
    log.info(`Analytics event ${name} fired.`, mergedData);
  }
}

export function sendSignal(name, props, data) {
  let responseMessage = 'Eva.js was not found';
  try {
    const { RVN, Eva } = window;
    if (RVN && Eva) {
      const mergedData = JSON.parse(JSON.stringify({ ...sanitizeProps(props), ...data }));
      Eva.signal(name, window, mergedData);
      logAnalitycsEvent(name, mergedData);
      responseMessage = 'Signal sended successfully';
    }
  } catch (error) {
    // Need console feedback as a last resort
    // eslint-disable-next-line no-console
    console.error('There were an error trying to parse the data: ', error);
    responseMessage = `Error: ${error}`;
  }
  return responseMessage;
}

function analyze(args) {
  const {
    name, props, data, isEnabled = true,
  } = args;
  if (!isEnabled) return 'Analytics is not enabled';
  return sendSignal(name, props, data);
}

export default analyze;
